module.exports = __webpack_public_path__ + "static/media/captivating-color-pallete.e50aabc0.png";